/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import * as labPersonalApi from "../../service/labPersonalApi";
import "moment/locale/th";
import { useParams, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import PageHeader from "../pageheader/PageHeader";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";

function LaboratoryDocumentGuideShow() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const laboratoryUser = JSON.parse(localStorage.getItem("user"));
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [guideLineDetail, setGuideLineDetail] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      laboratoryUser?.auth?.role[0] !== "LABORATORY_PERSONNEL" &&
      laboratoryUser?.auth?.role[0] !== "LABORATORY_ADMIN"
    ) {
      nav(RedirectCode400(404));
    } else {
      getGuideLineDetail();
    }
  }, []);

  const getGuideLineDetail = async () => {
    setLoading(true);
    let res = await labPersonalApi.getGuideLineDetail(id);
    // console.log(res)
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setGuideLineDetail(res["data"]["guideline_data"]);
      } else if (res["data"]["code"] === 403 || res["data"]["code"] === 404) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง", url: "/inspectionGuide" },
    { name: guideLineDetail?.title, url: "#" },
  ];

  return (
    <>
      <div className="global-page">
        <HeadBar menu="documentGuide" />
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="แนวทางการตรวจ" />

        <div className="w-full flex flex-col justify-center items-center my-[4rem] gap-6">
          <div className="w-[730px]">
            <h1 className="text-[1.5rem]">{guideLineDetail?.title}</h1>
            <div className="w-full h-auto mt-[4rem]">
              <div
                className="text-[1.2rem] my-6"
                dangerouslySetInnerHTML={{ __html: guideLineDetail?.detail }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LaboratoryDocumentGuideShow;
